import { render, staticRenderFns } from "./VBudget.vue?vue&type=template&id=31fa1d5d&"
import script from "./VBudget.vue?vue&type=script&lang=js&"
export * from "./VBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports